import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

// ============================================
// Container & Layout
// ============================================
export const PageContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
  padding: '32px',
  width: '100%',
});

// ============================================
// Tabs
// ============================================
export const TabContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: '56px',
  borderBottom: '1px solid #d9d9d9',
});

export const TabButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'isActive',
})(({ isActive }) => ({
  height: '56px',
  padding: '12px 32px',
  fontSize: '18px',
  fontWeight: isActive ? 600 : 500,
  color: isActive ? '#4ab3bc' : '#737373',
  borderBottom: isActive ? '4px solid #4ab3bc' : '1px solid #737373',
  borderRadius: 0,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));
